import api from './api';
import apiGraphQL from './apiGraphQL';
import {TeamSessionGroup} from '../interfaces';

export function getTeamSessionGroupDetail(id: number) {
  return new Promise<TeamSessionGroup>((resolve, reject) => {
    try {
      api
        .get(`/teamsessiongroups/${id}`)
        .then(response => {
          resolve(response.data);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getPlayersTeamSessionGroup(
  teamSessionGroupId: number,
  profileId: number,
) {
  return new Promise<TeamSessionGroup>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `query ($teamSessionGroupId: Int!, $profileId: Int!) {
            teamSessionGroup(teamSessionGroupId: $teamSessionGroupId, profileId: $profileId) {
              id
              teamSessions {
                id
                teamId
                startTime
                type
                sessionTags {
                  id
                  name
                  code
                  isPlayerSessionTag
                  isTeamSessionTag
                }
                playerSessions {
                  id
                  type
                  startTime
                  endTime
                  strideCountLeft
                  strideCountRight
                  activeTime
                  timeOnIce
                  energyRatio
                  points
                  strintFilteredStrideRateAvgV2
                  strintFilteredStrideRateMaxV2
                  speedAvgV2
                  accelAvgV2
                  speedMaxV2
                  accelMaxV2
                  hustleScore
                  hustleScoreTopLevel
                  balance
                  balanceNormalized
                  strintTotalTime
                  hrAvg
                  localDisplayStartTime
                  timeZone
                  speedAvgDataV2 {
                    value
                    time
                  }
                  accelAvgDataV2 {
                    value
                    time
                  }
                  strideRateAvgDataV2 {
                    value
                    time
                  }
                  balanceAvgData {
                    value
                    time
                  }
                  heartRateData {
                    value1
                    time
                  }
                  teamSessionId
                  playerSessionShifts {
                    id
                    start
                    startTime
                    end
                    endTime
                    strideCountLeft
                    strideCountRight
                    strideCountTotal
                    strintStrideCountTotal
                    speedAvgV2
                    speedMaxV2
                    accelAvgV2
                    accelMaxV2
                    strideRateAvg
                    strintFilteredStrideRateAvgV2
                    strintFilteredStrideRateMaxV2
                    balance
                    balanceNormalized
                    strintTotalTime
                    energyRatio
                    hrMin
                    hrMax
                    hrAvg
                    hrStart
                    hrEnd
                    timeOnIce
                    deviceTimeOnIce
                    valid
                    validInitially
                    canUpdateValid
                    isFavorite
                    localDisplayStartTime
                    playerSessionVideoClips {
                      id
                      key
                      startTime
                      endTime
                      url
                    }
                    shiftTags {
                      id
                      name
                    }
                  }
                  player {
                    id
                    number
                    profile {
                      id
                      firstName
                      lastName
                      position
                      profilePictureUrl
                    }
                  }
                  baseline {
                    id
                    accelAvgV2
                    accelMaxV2
                    strintFilteredStrideRateAvgV2
                    strintFilteredStrideRateMaxV2
                    speedAvgV2
                    speedMaxV2
                    hrAvg
                    hrMax
                    balanceNormalized
                    energyRatio
                    hustleScoreTopLevel
                  }
                  sessionDetail {
                    id
                    locationType
                    opponentName
                    teamScore
                    opponentScore
                  }
                }
              }
            }
          }`,
          variables: {
            teamSessionGroupId,
            profileId,
          },
        })
        .then(response => {
          resolve(response.data.data.teamSessionGroup);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
